import React from 'react'

const SlideshowArrowLeft = ({ direction, className, onClick }) => (
  <svg
    viewBox="0 0 300 300"
    direction={direction}
    className={className}
    onClick={onClick}
  >
    <path
      fill="none"
      stroke="#afad9f"
      strokeWidth={14.204}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M173.4 250.4L73 150 173.4 49.6"
    />
  </svg>
)

export default SlideshowArrowLeft



// WEBPACK FOOTER //
// ./src/components/svgs/slideshow-arrow-left/index.js